// Organization Enums
// These enums are used for organization-related fields

export const Organization_LegalType = {
  COMPANY_LIMITED: 'Công ty TNHH',
  JOINT_STOCK: 'Công ty cổ phần',
  BUSINESS_HOUSEHOLD: 'Hộ kinh doanh',
  NGO: 'Tổ chức phi chính phủ',
  COOPERATIVE: 'Hợp tác xã',
  PARTNERSHIP: 'Công ty hợp danh',
  STATE_OWNED: 'Doanh nghiệp nhà nước',
  FOREIGN_INVESTED: 'Doanh nghiệp FDI',
  INDIVIDUAL_BUSINESS: 'Doanh nghiệp tư nhân'
} as const;

export const Organization_Status = {
  ACTIVE: 'Hoạt động',
  SUSPENDED: 'Tạm ngừng',
  DISSOLVED: 'Giải thể',
  PENDING: 'Chờ xét duyệt',
  INACTIVE: 'Ngừng hoạt động'
} as const;

export const Organization_Industry = {
  TECHNOLOGY: 'Công nghệ thông tin',
  MANUFACTURING: 'Sản xuất',
  CONSTRUCTION: 'Xây dựng',
  AGRICULTURE: 'Nông nghiệp',
  EDUCATION: 'Giáo dục',
  HEALTHCARE: 'Y tế',
  FINANCE: 'Tài chính - Ngân hàng',
  RETAIL: 'Bán lẻ',
  TRANSPORT: 'Vận tải',
  TOURISM: 'Du lịch',
  REAL_ESTATE: 'Bất động sản',
  ENERGY: 'Năng lượng',
  TELECOMMUNICATIONS: 'Viễn thông',
  FOOD_BEVERAGE: 'Thực phẩm - Đồ uống',
  CONSULTING: 'Tư vấn',
  LOGISTICS: 'Logistics',
  MEDIA: 'Truyền thông',
  ENTERTAINMENT: 'Giải trí',
  MINING: 'Khai thác mỏ',
  CHEMICAL: 'Hóa chất',
  TEXTILE: 'Dệt may',
  AUTOMOTIVE: 'Ô tô',
  ELECTRONICS: 'Điện tử',
  PHARMACEUTICAL: 'Dược phẩm',
  OTHER: 'Khác'
} as const;

// Type definitions for TypeScript
export type LegalType = typeof Organization_LegalType[keyof typeof Organization_LegalType];
export type OrganizationStatus = typeof Organization_Status[keyof typeof Organization_Status];
export type Industry = typeof Organization_Industry[keyof typeof Organization_Industry];

// Helper functions to get enum values as arrays
export const getLegalTypeOptions = () => Object.values(Organization_LegalType);
export const getOrganizationStatusOptions = () => Object.values(Organization_Status);
export const getIndustryOptions = () => Object.values(Organization_Industry);

// Helper functions to get enum entries as key-value pairs
export const getLegalTypeEntries = () => Object.entries(Organization_LegalType);
export const getOrganizationStatusEntries = () => Object.entries(Organization_Status);
export const getIndustryEntries = () => Object.entries(Organization_Industry);

// Default values
export const ORGANIZATION_DEFAULT_LEGAL_TYPE = Organization_LegalType.COMPANY_LIMITED;
export const ORGANIZATION_DEFAULT_STATUS = Organization_Status.ACTIVE;
export const ORGANIZATION_DEFAULT_COUNTRY = 'Việt Nam';